import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import ButtonVariant from "app/components/Button/ButtonVariant";
import styles from "./customPrompt.module.scss";

type ConfirmDialogProps = {
  message: string;
  onYes: () => void;
  onCancel: () => void;
  onClosed: () => void;
};

const ConfirmDialog = ({ message, onYes, onCancel, onClosed }: ConfirmDialogProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (isOpen) {
      return undefined;
    }
    const id = window.setTimeout(onClosed, 0);
    return () => window.clearTimeout(id);
  }, [isOpen, onClosed]);

  const handleYes = () => {
    setIsOpen(false);
    onYes();
  };

  const handleCancel = () => {
    setIsOpen(false);
    onCancel();
  };

  return (
    <ModalLayout isOpen={isOpen} onClose={handleCancel} classNames={styles.modal}>
      <div className={styles.content}>
        <div className={styles.header}>
          <i className={`ico ico-info ${styles.icon}`} />
        </div>
        <p className={styles.message}>{message}</p>
        <div className={styles.actions}>
          <ButtonVariant
            buttonType="secondary-outline"
            title={t("Cancel")}
            onClickFunc={handleCancel}
          />
          <ButtonVariant
            buttonType="primary"
            title={t("Yes")}
            onClickFunc={handleYes}
          />
        </div>
      </div>
    </ModalLayout>
  );
};

const customPrompt = ({
  message,
  onYes,
  onCancel,
}: {
  message: string;
  onYes: () => void;
  onCancel: () => void;
}) => {
  const container = document.createElement("div");
  document.body.appendChild(container);

  const cleanup = () => {
    ReactDOM.unmountComponentAtNode(container);
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
  };

  ReactDOM.render(
    <ConfirmDialog
      message={message}
      onYes={onYes}
      onCancel={onCancel}
      onClosed={cleanup}
    />,
    container,
  );
};

export default customPrompt;
